import { DocumentType } from '@/models/document-type.enum';
import { DocumentModel } from '@/models/document.model';
import { ValidatorResult } from '@/models/validation-result.model';
import { CrudService } from './crud.service';

export class OrderDocumentService {
  private legacyDocumentService: CrudService<DocumentModel>;
  private documentsService: CrudService<DocumentModel>;

  constructor() {
    this.legacyDocumentService = new CrudService<DocumentModel>('orders/documents');
    this.documentsService = new CrudService<DocumentModel>('documents');
  }

  public async get(
    orderNumber: string,
    documentId: string,
    accountId: string,
    documentType?: DocumentType,
  ): Promise<ValidatorResult<DocumentModel>> {
    // not necessary the best we to identify sf1 order vs dyn but we cannot use the account cause he may have both dyn and old sf1 orders
    if (orderNumber.startsWith('SO-')) {
      return this.legacyDocumentService.do(
        'get',
        `${orderNumber}?documentId=${documentId}&accountId=${accountId}`,
        undefined,
        undefined,
        'silent',
      );
    } else {
      return this.documentsService.do(
        'get',
        `?documentType=${documentType}&ids=${orderNumber},${documentId}&orderNumber=${orderNumber}&accountId=${accountId}`,
        undefined,
        undefined,
        'silent',
      );
    }
  }
}
